module.exports = __webpack_public_path__ + "static/media/c8.3154cd6f.jpg";